import { CardContent } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OrderConfirmationMessage from "./OrderConfirmationMessage";
import {
  OneSolomonContentPage,
  OneSolomonPageBackground,
  resolveIsCompanyOneSolomons,
} from "./oneSolomonUi";

type LocationState = {
  company_uuid?: string;
  isCompanyOneSolomons?: boolean;
};

const OrderConfirmationPreviousOrderUpdate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as LocationState | null;

  const isCompanyOneSolomons = resolveIsCompanyOneSolomons(
    locationState?.company_uuid,
    locationState?.isCompanyOneSolomons
  );

  useEffect(() => {
    if (location.state === null) {
      navigate("/", { replace: true });
    }
  }, [location.state, navigate]);

  if (isCompanyOneSolomons) {
    return (
      <>
        <OneSolomonPageBackground />
        <OneSolomonContentPage cardMaxWidthPx={800}>
          <OrderConfirmationMessage />
        </OneSolomonContentPage>
      </>
    );
  }

  return (
    <CardContent>
      <OrderConfirmationMessage />
    </CardContent>
  );
};

export default OrderConfirmationPreviousOrderUpdate;
